import { createSelector } from 'reselect';

const selectDesignations = (state: any) => state.designations;


export const selectDesignationsCurrentItem = createSelector([selectDesignations], (designations) => designations.current);

export const selectDesignationsListItems = createSelector([selectDesignations], (designations) => designations.list);

export const selectDesignationsItemById = (itemId: any) =>
    createSelector(selectDesignationsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDesignationsCreatedItem = createSelector([selectDesignations], (designations) => designations.create);

export const selectDesignationsUpdatedItem = createSelector([selectDesignations], (designations) => designations.update);

export const selectDesignationsReadItem = createSelector([selectDesignations], (designations) => designations.read);

export const selectDesignationsDeletedItem = createSelector([selectDesignations], (designations) => designations.delete);

export const selectDesignationsSearchedItems = createSelector([selectDesignations], (designations) => designations.search);

export const selectDesignationsItemsCount = createSelector([selectDesignations], (designations) => designations.count);

export const selectDesignationsItemsFilter = createSelector([selectDesignations], (designations) => designations.filter);